module.exports = __webpack_public_path__ + "img/renderman.6f1c0d8d.svg";